import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [ "provider", "deliveryMethod", "section" ]

  connect() {
    this.update()
  }

  update() {
    this.syncDeliveryMethodOptions()
    this.sectionTargets.forEach((section) => {
      const visible = this.sectionMatches(section)
      section.hidden = !visible
      this.toggleSectionInputs(section, visible)
    })
  }

  syncDeliveryMethodOptions() {
    const supportedMethods = this.supportedDeliveryMethods()

    Array.from(this.deliveryMethodTarget.options).forEach((option) => {
      const enabled = supportedMethods.includes(option.value)
      option.disabled = !enabled
      option.hidden = !enabled
    })

    if (!supportedMethods.includes(this.deliveryMethodTarget.value)) {
      this.deliveryMethodTarget.value = supportedMethods[0]
      this.deliveryMethodTarget.dispatchEvent(new Event("input"))
    }
  }

  sectionMatches(section) {
    const providers = this.valuesFrom(section.dataset.providers)
    const methods = this.valuesFrom(section.dataset.methods)

    return this.includesOrEmpty(providers, this.providerTarget.value) &&
      this.includesOrEmpty(methods, this.deliveryMethodTarget.value)
  }

  supportedDeliveryMethods() {
    switch (this.providerTarget.value) {
      case "sendgrid":
      case "postmark":
      case "mailgun":
        return [ "smtp", "api" ]
      default:
        return [ "smtp" ]
    }
  }

  valuesFrom(value) {
    return (value || "")
      .split(",")
      .map((item) => item.trim())
      .filter(Boolean)
  }

  includesOrEmpty(values, currentValue) {
    return values.length === 0 || values.includes(currentValue)
  }

  toggleSectionInputs(section, visible) {
    section.querySelectorAll("input, select, textarea, button").forEach((element) => {
      if (element === this.providerTarget || element === this.deliveryMethodTarget) return

      if (visible) {
        if (element.dataset.deliveryAccountFormHiddenDisabled === "true") {
          element.disabled = false
          delete element.dataset.deliveryAccountFormHiddenDisabled
        }
      } else if (!element.disabled) {
        element.disabled = true
        element.dataset.deliveryAccountFormHiddenDisabled = "true"
      }
    })
  }
}
